import Link from 'components/Link'
import PropTypes from 'prop-types';

const MarketInsightLinksBlockListColumnItem = {};

MarketInsightLinksBlockListColumnItem.propTypes = {
    link: PropTypes.exact(Link.propTypes).isRequired
}

export default MarketInsightLinksBlockListColumnItem;